module.exports = __webpack_public_path__ + "img/svg/alert-round.1289402e3ef8ad6c0f6ac50ccee649d5.svg";